module.exports = __webpack_public_path__ + "img/kos45-01.750785ee.png";